import axios from 'axios';


 export const api = axios.create({
    baseURL: 'https://cdn.contentful.com/spaces/eo55qh7yxbyl',
    timeout: 9000,
    // headers: {'X-Custom-Header': 'foobar'}
  });